import { CustomButton } from '@/components/molecules/CustomButton';
import { type OwnedPokemon } from '@/services/pokemon';
import { cdnUrl } from '@/utils/cdn';

interface SelectedPokemonPanelProps {
  selected: OwnedPokemon | null;
  onConfirm?: () => void;
  confirmLabel?: string;
  loading?: boolean;
  className?: string;
}

export const SelectedPokemonPanel = ({
  selected,
  onConfirm,
  confirmLabel = 'Confirmer',
  loading = false,
  className,
}: SelectedPokemonPanelProps) => (
  <div
    className={`flex items-center justify-between gap-3 rounded-2xl border p-4 transition-colors ${
      selected ? 'border-primary-400/30 bg-primary-500/10' : 'border-line-soft bg-raised'
    } ${className ?? ''}`}
  >
    <div className="flex min-w-0 items-center gap-3">
      {selected ? (
        <>
          <img
            src={cdnUrl(selected.isShiny ? selected.pokemon.spriteShiny : selected.pokemon.sprite)}
            alt={selected.nickname}
            className="h-10 w-10 shrink-0 object-contain"
            onError={(e) => { e.currentTarget.style.opacity = '0'; }}
          />
          <div className="min-w-0">
            <p className="text-content font-lexend truncate text-sm font-semibold">
              {selected.nickname}
            </p>
            <p className="text-content/50 text-xs">
              {selected.pokemon.realname} · Nv.&nbsp;{selected.level}
            </p>
          </div>
        </>
      ) : (
        <p className="text-content/40 text-sm">Aucun Pokémon sélectionné</p>
      )}
    </div>

    <CustomButton
      title={confirmLabel}
      color="primary"
      size="sm"
      rounded="full"
      disabled={!selected}
      loading={loading}
      onClick={onConfirm}
    />
  </div>
);
